'use client';

import { alpha, Stack, Typography } from "@mui/material";

interface CounterProps {
    current: number;
    total: number;
}

export default function Counter({ current, total }: CounterProps) {
    return (
        <Stack
            spacing={1}
            direction="row"
            role="status"
            aria-live="polite"
            aria-label={`Bild ${current + 1} von ${total}`}
            sx={(theme)=> ({
                position: "absolute",
                left: '50%',
                top: theme.spacing(2),
                padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
                color: theme.palette.common.white,
                backgroundColor: alpha(theme.palette.background.paper, .5),
                zIndex: 100,
            })}
        >
            <Typography variant="body2">{current + 1}</Typography>
            <Typography variant="body2">/</Typography>
            <Typography variant="body2">{total}</Typography>
        </Stack>
    )
}
